<template>
  <div class="flex-col justify-start page">
    <div class="flex-col justify-start section">
      <div class="flex-col section_2 space-y-24">
        <div class="flex-col group space-y-26">
          <div class="toptitle">
            <img
              class = "shrink-0 image_01"
              src="../../assets/turn_logo.png"
            />
          </div>
          <div class="flex-row justify-between items-center">
            <div class="flex-row" style="flex: 1">
              <div
                class="flex-col justify-start items-center text-wrapper"
                @click="subPage"
              >
                <span class="font_1 text">提交文章</span>
              </div>
              <div class="flex-col justify-start items-center text-wrapper_2">
                <span class="font_1 text_2">查看报告</span>
              </div>
            </div>
            <div class="flex-row items-center section_3">
              <span class="font_2" style="cursor: pointer" @click="toTaobao"
              >商家店铺</span
              >
              <div class="shrink-0 section_4"></div>
              <img
                class="shrink-0 image image_2"
                src="../../assets/d74a37279a8be9c88380ef8c061c1386.png"
              />
              <span
                class="font_2 text_3"
                style="cursor: pointer"
                @click="contactWW"
              >和我联系</span
              >
            </div>
          </div>
          <div class="divider"></div>
          <div class="flex-col section_5 space-y-74">
            <div class="flex-col">
              <div class="flex-row items-center">
                <span class="font_3 text_4">订单编号：</span>
                <Input
                  v-model="orderno"
                  placeholder="请输入订单编号查询检测结果"
                  class="flex-col justify-start items-start text-wrapper_3"
                />
                <div
                  class="flex-row items-center section_6 space-x-4"
                  @click="getPageList"
                >
                  <img
                    class="shrink-0 image"
                    src="../../assets/65a519e4e62abbf94614ea625b0531ee.png"
                  />
                  <span class="font_2">查询结果</span>
                </div>
                <span class="font_3 text_5" @click="subPage">再检测一篇</span>
              </div>
              <!--            <span class="self-start font_3 text_7" v-if="resultData.length>0">由于您一次性检测超过{{paginations.total}}单，系统为您按照包月账号优惠结算！</span>-->
              <div
                class="resultdata flex-col group space-y-16"
                v-if="resultData.length > 0"
              >
                <div
                  class="flex-row items-center section_7"
                  v-for="(item, index) in resultData"
                  :key="index"
                >
                  <div class="flex-row items-center group_2 space-x-16">
                    <div class="flex-row space-x-16">
                      <div
                        class="items-center relative group_3"
                        
                      >
                        <i-circle
                          :percent="item.repetition_rate"
                          size="72"
                          :strokeColor="strokeColor"
                          trailColor="#F2F3F5"
                          strokeWidth="15"
                          trailWidth="15"
                        >
                          <span v-if="item.repetition_rate"
                            class="demo-Circle-inner font_5"
                            style="font-size: 12px"
                          >{{ item.repetition_rate }}%</span>

                          <span v-else-if = "item.ai_per"
                            class="demo-Circle-inner font_5"
                            style="font-size: 12px"
                          >不查</span>
                          <span v-else>
                            检测中
                          </span>
                          <span class="font_9 text_8">重复率</span>
                        </i-circle>
                      </div>
                      <div
                        class="items-center relative group_3"
                        v-if="item.ai_file"
                      >
                        <i-circle
                          :percent="parseInt(item.ai_per * 100)"
                          size="72"
                          :strokeColor="strokeAiColor"
                          trailColor="#F2F3F5"
                          stroke-width="15"
                          trailWidth="15"
                        >
                          <div class="demo-Circle-inner font_5">
                            <span class="font_3" v-if="item.ai_per" style="color: black">{{ parseInt(item.ai_per * 100) }}%</span>
                            <span class="font_9 text_8" v-else style="color: black">1%-19%</span>
                          </div>
                          <span class="font_9 text_8">AI比率</span>
                        </i-circle>
                      </div>
                    </div>
                    <div class="flex-row items-end space-x-10">
                      <div class="flex-col items-start space-y-10">
                        <span class="font_3">类型</span>
                        <span class="font_7">Turnitin</span>
                      </div>
                      <img
                        class="image_4"
                        src="../../assets/14599b67e41eeefa6c7ffe861f0aba98.png"
                      />
                    </div>
                  </div>
                  <div class="flex-col items-start group_4 space-y-8">
                    <span class="font_3">标题</span>
                    <span class="font_8">{{ item.title }}</span>
                  </div>
                  <div class="flex-col items-start group_4 space-y-8" style="flex: 1">
                    <span class="font_3">{{ splitNumber(item.created_at) }}</span>
                    <span class="font_8" v-if="item.status == 0" style="color: red">AI检测中...</span>
                    <span class="font_8" v-else-if="item.status == null" style="color: red">AI检测中...</span>
                    <span class="font_8" v-else style="color: green">检测完成</span>
                  </div>
                  <div class="flex-col" title="下载">
                    <div class="flex-row section_8 space-x-12"
                      title="AI检测报告"
                      @click="downFile(item.ai_file)"
                      v-if="item.ai_file"
                    >
                      <img
                        class="shrink-0 image_4"
                        src="../../assets/471a584ad37abd5771be97b726c914af.png"
                      />
                      <span class="font_6">下载AI报告</span>
                    </div>
                    <div class="flex-row section_8 space-x-12" title="下载查重报告" @click="downFile(item.report_file)" v-if="item.report_file">
                      <img class="shrink-0 image_4" src="../../assets/471a584ad37abd5771be97b726c914af.png"/>
                      <span class="font_6">下载查重报告</span>
                    </div>
                    <div class="flex-row section_8 space-x-12" title="下载英文秘籍" @click="downFile(item.infor_file)" v-if="item.infor_file">
                      <img class="shrink-0 image_4" src="../../assets/471a584ad37abd5771be97b726c914af.png"/>
                      <span class="font_6">下载英文秘籍</span>
                    </div>
                  </div>
                  <div class="deletereport" @click="deleteReport(item.id)">
                    <Icon type="ios-trash-outline" />
                  </div>
                </div>
              </div>
              <Alert
                show-icon
                v-if="resultData.length == 0"
                style="margin-top: 2rem"
              >
                提示：
                <template #icon>
                  <Icon type="ios-bulb-outline"></Icon>
                </template>
                <template #desc>暂未查到结果！</template>
              </Alert>
              <div class="flex-col justify-start self-start text-wrapper_4">
                <span class="font_3 text_10" style="color: green"
                >*%, 官网升级后，ai率1-19%之间不显示ai率以及ai有问题的具体内容！</span
                >
                <span class="font_3 text_10"
                >温馨提示：报告保存期为1天，请及时下载！</span
                >
                <span class="font_3 text_10"
                >提交订单后，请耐心等待，查重结果在10分钟内出结果，ai检测结果20分钟内出结果。如果超时未出结果，请联系客服解决！</span
                >
              </div>
            </div>
            <pageItem
              :paginations="{ ...paginations }"
              @changepage="changepage"
              @pageSizeChange="pageSizeChange"
              v-if="resultData.length > 0 && paginations.total > 4"
              class="custompage"
            />
            <div class="flex-col justify-start items-center relative section_0">
                <img
                  class = "shrink-0 image_0"
                  src="../../assets/connect2.png"
                >
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal v-model="modal1" width="360">
      <template #header>
        <p style="color:#f60;text-align:center">
          <Icon type="ios-information-circle"></Icon>
          <span>删除记录</span>
        </p>
      </template>
      <div style="text-align:center">
        <p>删除后无法恢复，确认删除吗？</p>
      </div>
      <template #footer>
        <Button type="error" size="large" long :loading="modal_loading" @click="del">删除</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
    import pageItem from "../../components/common/PageItem";

    export default {
        components: {pageItem},
        data() {
            return {
                paginations: {
                    // 初始化信息总条数
                    total: 4,
                    // 每页显示多少条
                    pageSize: 4,
                    // 每页条数切换的配置
                    pageSizeOpts: [4,10,20],
                    current: 1, //当前位于哪页
                    showTotal: true,
                },
                strokeColor: ["#00B42A", "#F53F3F", "#F53F3F"],
                strokeAiColor: ["#fff51b", "#f5121f", "#f5121f"],
                orderno: this.$route.params.orderno ? this.$route.params.orderno : "",
                resultData: {},
                taobaolink: "",
                modal1: false,
                modal_loading: false,
                deleteid: 0,
                timer: null,
                num:0,
            };
        },
        destroyed() {
          //离开页面后销毁
          clearInterval(this.timer);
          this.timer = null;
        },
        created(){
          //实现轮询
          this.getPageList();
          this.timer = window.setInterval(() => {
              setTimeout(this.getPageList(), 0);
            }, 30000);
        },
        mounted() {
            this.getConfig();
        },
        methods: {
            stop(){
              clearInterval (this.timer);
              this.timer = null;
            },
            splitNumber(str) {
                var str = '' + str;
                return str.substring(0, 16)
            },
            contactWW() {
                //var href="http://amos.im.alisoft.com/msg.aw?v=2&uid=毕业果旗舰店&site=cntaobao&s=1&charset=utf-8";
                //var href =
                //    "http://amos.alicdn.com/msg.aw?v=2&uid=毕业果旗舰店&site=cnalichn&s=10&charset=gbk";
                //window.open(href, "_blank");
                window.open(this.contractlink, "_blank");
            },
            toTaobao() {
                // var taobaolink = 'https://detail.tmall.com/item.htm?abbucket=0&id=701741298341&ns=1&spm=a21n57.1.0.0.1c6d523cLyEfv2';
                //var taobaolink = this.taobaolink;
                window.open(this.taobaolink, "_blank");
            },
            downFile(url) {
                //window.location.href = url;
                window.open(url, "_blank"); //打开新窗口
            },
            getConfig() {
              var params = {shop: "Biyeguo"};
                this.http.post(this.api.getConfig, params).then((res) => {
                    console.log(res.data);
                    // 循环遍历，当explain是“商家店铺”的时候，就是淘宝链接
                    for (let i = 0; i < res.data.length; i++) {
                        if (res.data[i].shop == "Biyeguo") {
                            this.taobaolink = res.data[i].shop_url;
                            this.contractlink = res.data[i].contract_url;
                        }
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },
            deleteReport(id) {
              this.modal1 = true;
              this.deleteid = id;
            },
            del () {
                var _this = this;
                this.modal_loading = true;
                if(this.deleteid > 0){
                    this.http.post(this.api.deleteRecord, {id:this.deleteid}).then((res) => {
                        console.log(res.data);
                        let data = res.data;
                        _this.deleteid = 0;
                        _this.modal_loading = false;
                        _this.modal1 = false;
                        if (data.code == 200) {
                            _this.$Message.success('删除成功');
                            _this.resultData = [];
                            _this.getPageList();
                        }else{
                            _this.$Message.error('删除失败');
                        }
                    }).catch((error) => {
                        console.log(error);
                    });
                }
            },
            getPageList(pageIndex = 1, pageSize = 4) {
                console.log("this.paginations.current：" + this.paginations.current);
                console.log("pageIndex：" + pageIndex);
                if (!this.orderno) {
                    this.$Message["error"]({
                        background: true,
                        content: "请输入订单编号查询",
                    });
                    this.stop();
                    return false;
                }
                var params = {
                    limit: pageSize,
                    page: this.paginations.current,
                    order_no: this.orderno,
                    checktype: "US",
                    shop: "Biyeguo",
                };
                this.http.post(this.api.searchResults, params).then((res) => {
                    let {code, data} = res.data;
                    if (code == 200) {
                        this.resultData = data.data;
                        this.paginations.total = data.total;
                        if ((this.resultData[0].status != 0) && (this.resultData[0].status != null)){
                          this.stop();
                        }
                    }
                    if (code == 400){
                      this.$Message["error"]({
                        background: true,
                        content: "无效订单号，请更换订单号查询结果",
                      });
                      this.stop();
                    }
                    this.num++;
                    if (this.num > 40){
                      this.stop();
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
            },
            
            //切换当前页
            changepage(page) {
                this.paginations.current = page;
                this.getPageList(page, this.paginations.pageSize);
            },
            //切换每页条数时的回调，返回切换后的每页条数
            pageSizeChange(page_size) {
                this.paginations.current = 1; //当前页
                this.paginations.pageSize = page_size; //所点击的条数,传给一页要显示多少条
                this.getPageList(this.paginations.current, page_size);
            },
            subPage() {
                this.$router.push({name: "Page_1"});
            },
        },
    };
</script>

<style scoped lang="less">
  .page {
    background-color: hsl(216, 33.3%, 97.1%);
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    //background-image: url("../../assets/ce7ff01aba72f7404e311255ef4f789c.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .toptitle {
      color: hsl(207, 82%, 32%);
      font-size: 40px;
      //margin: 0 auto 1rem;
      text-align: left;
    }
    .section {
      .section_2 {
        .group {
          width: 100%;
          max-width: 75rem;
          margin: 0 auto;
          padding: 0 1rem;
        }

        padding: 4.75rem 7.5rem 4.5rem;
        //background-color: hsla(0, 0%, 0%, 0.3);
        //backdrop-filter: blur(0.13rem);

        .text-wrapper {
          cursor: pointer;
          padding: 0.75rem 0;
          background-color: hsla(0, 0%, 100%, 0.3);
          border-radius: 0.5rem 0px 0px 0.5rem;
          width: 6.38rem;
          height: 2.5rem;

          .text {
            color: hsl(207, 82%, 32%);
          }
        }

        .text-wrapper_2 {
          padding: 0.75rem 0;
          background-color: hsl(207, 82%, 32%);
          border-radius: 0px 0.5rem 0.5rem 0px;
          width: 6.38rem;
          height: 2.5rem;

          .text_2 {
            color: hsl(0, 0%, 100%);
            line-height: 0.91rem;
          }
        }

        .font_1 {
          font-size: 1rem;
          //font-family: PingFang HK;
          line-height: 0.94rem;
        }

        .section_3 {
          padding: 0.5rem 1.38rem 0.5rem 1.5rem;
          background-color: hsla(0, 0%, 0%, 0.3);
          border-radius: 0.25rem;
          height: 2rem;

          .section_4 {
            margin-left: 0.88rem;
            background-color: hsla(0, 0%, 100%, 0.3);
            border-radius: 0.25rem;
            width: 0.063rem;
            height: 1rem;
          }

          .image_2 {
            margin-left: 1rem;
          }

          .text_3 {
            margin-left: 0.25rem;
          }
        }

        .divider {
          background-color: hsl(207, 82%, 32%);
          height: 0.13rem;
        }

        .section_5 {
          padding: 3.75rem 6.5rem 3rem;
          background-color: hsl(0, 0%, 100%);
          border-radius: 0.25rem;
          min-height: 40rem;

          .font_3 {
            font-size: 0.88rem;
            //font-family: PingFang SC;
            line-height: 1.2rem;
            color: hsl(225, 3%, 74.1%);
          }

          .text_4 {
            color: hsl(0, 0%, 0%);
          }

          .text-wrapper_3 {
            margin-left: 0.13rem;
            border-radius: 0.25rem;
            width: 22.88rem;
            height: 1.88rem;

            .text_6 {
              margin-left: 0.5rem;
              color: hsl(220, 17.1%, 13.7%);
              line-height: 0.66rem;
            }
          }

          .section_6 {
            cursor: pointer;
            margin-left: 1rem;
            padding: 0.5rem 1.5rem;
            background-color: hsl(207, 82%, 32%);
            border-radius: 0.25rem;
            height: 2rem;
          }

          .space-x-4 {
            & > *:not(:first-child) {
              margin-left: 0.25rem;
            }
          }

          .text_5 {
            cursor: pointer;
            margin-left: 1rem;
            color: hsl(216, 14.8%, 35.9%);
          }

          .text_7 {
            margin-top: 1.75rem;
            color: hsl(134, 100%, 35.3%);
            line-height: 0.88rem;
          }

          .group {
            margin-top: 1.13rem;

            .section_7 {
              padding: 0.5rem 1rem;
              background-color: hsl(0, 0%, 100%);
              border-radius: 0.5rem;
              filter: drop-shadow(0px 0.25rem 0.31rem #0000001a);
              overflow: hidden;
              border: solid 0.063rem hsl(220, 13%, 95.5%);
              position: relative;
              .group_2 {
                width: 16.16rem;

                .space-x-8 {
                  & > *:not(:first-child) {
                    margin-left: 0.5rem;
                  }

                  .space-y-10 {
                    & > *:not(:first-child) {
                      margin-top: 0.63rem;
                    }

                    .font_7 {
                      font-size: 1rem;
                      //font-family: PingFang SC;
                      line-height: 0.72rem;
                      color: hsl(208, 11.9%, 21.4%);
                    }
                  }
                }
              }

              .space-x-16 {
                & > *:not(:first-child) {
                  margin-left: 1rem;
                }

                .group_3 {
                  padding: 1.63rem 0 1rem;
                  width: 4.5rem;

                  .font_5 {
                    font-size: 1rem;
                    font-family: Roboto;
                    line-height: 0.72rem;
                    font-weight: 700;
                    color: hsl(0, 0%, 0%);
                  }

                  .font_9 {
                    font-size: 0.63rem;
                    //font-family: PingFang HK;
                    line-height: 0.63rem;
                    color: hsl(216, 14.8%, 35.9%);
                  }

                  .text_8 {
                    margin-top: 0.63rem;
                    line-height: 0.59rem;
                    display: block;
                  }

                  .image_3 {
                    filter: drop-shadow(0px 0.19rem 0.16rem #00000033);
                    width: 4.5rem;
                    height: 4.5rem;
                  }

                  .pos {
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                  }

                  .text_9 {
                    margin-top: 0.63rem;
                    line-height: 0.59rem;
                  }

                  .pos_2 {
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                  }

                  .pos_3 {
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                  }

                  .pos_4 {
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                  }

                  .pos_5 {
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                  }

                  .pos_6 {
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                  }
                }
              }

              .group_4 {
                margin-left: 3.13rem;

                .font_8 {
                  font-size: 1rem;
                  //font-family: PingFang SC;
                  line-height: 1.2rem;
                  color: hsl(208, 11.9%, 21.4%);
                }
              }

              .space-y-8 {
                & > *:not(:first-child) {
                  margin-top: 0.5rem;
                }
              }

              .section_8 {
                /*margin-left: 3.13rem;*/
                padding: 0.63rem 0.5rem 0.5rem 0.5rem;
                border-radius: 0.25rem;
                height: 2.13rem;
                border: solid 0.063rem hsl(207, 82%, 32%);
                margin-bottom: 0.4rem;

                .font_6 {
                  font-size: 0.88rem;
                  //font-family: PingFang SC;
                  line-height: 1rem;
                  color: hsl(207, 82%, 32%);
                  flex-shrink: inherit;
                }
              }

              .image_4 {
                width: 0.81rem;
                height: 0.81rem;
              }
            }
          }

          .space-y-16 {
            & > *:not(:first-child) {
              margin-top: 1rem;
            }
          }

          .text-wrapper_4 {
            margin-top: 1.44rem;
            padding: 0.75rem 0 0.5rem;
            background-color: hsla(40, 100%, 59%, 0.1);
            border-radius: 0.13rem;
            height: auto;
            border: solid 0.063rem hsl(40, 95.8%, 52.9%);

            .text_10 {
              margin-left: 0.5rem;
              margin-right: 0.25rem;
              color: hsl(40, 95.8%, 52.9%);
              line-height: 0.88rem;
            }
          }

          .section_9 {
            margin-right: 1rem;
            padding: 0.5rem;
            border-radius: 0.25rem;
            width: 5rem;
            height: 1.88rem;
            border: solid 0.063rem hsl(216, 6.2%, 84.1%);

            .image_6 {
              width: 0.5rem;
              height: 0.31rem;
            }
          }

          .space-x-12 {
            cursor: pointer;

            & > *:not(:first-child) {
              margin-left: 0.75rem;
            }
          }

          .text-wrapper_5 {
            margin-right: 0.5rem;
            padding: 0.63rem 0;
            background-color: hsl(207, 82%, 32%);
            border-radius: 0.25rem;
            width: 1.88rem;
            height: 1.88rem;

            .text_11 {
              color: hsl(0, 0%, 100%);
            }
          }

          .font_4 {
            font-size: 0.88rem;
            //font-family: PingFang SC;
            line-height: 0.63rem;
            color: hsl(225, 3%, 74.1%);
          }

          .text-wrapper_6 {
            margin-right: 0.5rem;
            padding: 0.63rem 0;
            background-color: hsl(210, 11.1%, 96.5%);
            border-radius: 0.25rem;
            width: 1.88rem;
            height: 1.88rem;

            .text_12 {
              line-height: 0.66rem;
            }

            .text_13 {
              line-height: 0.66rem;
            }

            .text_14 {
              line-height: 0.66rem;
            }
          }

          .view {
            margin-right: 0.63rem;
          }

          .text_17 {
            margin-right: 0.5rem;
            line-height: 0.13rem;
          }

          .image_5 {
            margin-right: 1.5rem;
            border-radius: 0.25rem;
            width: 1.88rem;
            height: 1.88rem;
          }

          .font_10 {
            font-size: 0.88rem;
            //font-family: PingFang SC;
            line-height: 0.81rem;
            color: hsl(208, 11.9%, 21.4%);
          }

          .text_15 {
            margin-right: 0.25rem;
          }

          .text-wrapper_7 {
            padding: 0.5rem 0;
            border-radius: 0.25rem;
            width: 3.75rem;
            height: 1.88rem;
            border: solid 0.063rem hsl(216, 6.2%, 84.1%);

            .text_16 {
              color: hsl(208, 11.9%, 21.4%);
            }
          }
        }

        .space-y-74 {
          & > *:not(:first-child) {
            margin-top: 4.63rem;
          }
        }

        .image {
          width: 1rem;
          height: 1rem;
        }

        .font_2 {
          font-size: 0.88rem;
          //font-family: PingFang SC;
          line-height: 0.81rem;
          color: hsl(0, 0%, 100%);
        }
        .deletereport{
          position: absolute;
          top: 0;
          right: 0;
          background: hsl(207, 82%, 32%);
          color: #fff;
          font-size: 18px;
          border-radius: 5px;
          cursor: pointer;
        }
      }

      .space-y-24 {
        & > *:not(:first-child) {
          margin-top: 1.5rem;
        }
      }

      .space-y-26 {
        & > *:not(:first-child) {
          margin-top: 1.63rem;
        }
      }
    }
  }

  .custompage {
    text-align: center;
  }

  .resultdata .flex-row {
    flex: 1;
  }
  .resultdata .flex-col {
    flex: 1;
  }

  @media (max-width: 1320px) {
    .page .section .section_2 {
      .section_5 {
        padding: 1rem;
      }
    }
  }

  @media (max-width: 960px) {
    .page .section .section_2 {
      padding: 2rem;

      .group {
        max-width: 100%;
        width: 100%;
      }
    }
  }

  @media (max-width: 790px) {
    .page .section .section_2 {
      padding: 2rem;

      .section_5 {
        .text-wrapper_3 {
          width: 10rem;
        }

        .group {
          width: 100%;

          .section_7 {
            display: block;
            .group_4 {
              margin-left: 0;
              margin-top: 1rem;
            }

            .section_8 {
              margin-left: 0;
              margin-top: 1rem;
            }
          }
        }
      }
    }
  }

  @media (max-width: 550px) {
    .page .section .section_2 .section_5 .text_5 {
      display: none;
    }
  }
</style>
